// Vendors
import $ from 'jquery';

$(function () {
  // Open and Close All Functionality
  $('[data-toggle-group-show-all]').click(function () {
    if (this.classList.contains('accordion__section-open')) {
      $(this)
        .closest('section')
        .nextUntil('[id^=cat]')
        .find('[data-toggle-group^="accordion-panel"]')
        .trigger('toggle:groupShowAll');
      this.innerHTML = 'Close All';
      this.classList.remove('accordion__section-open');
    } else {
      $(this)
        .closest('section')
        .nextUntil('[id^=cat]')
        .find('[data-toggle-group^="accordion-panel"]')
        .trigger('toggle:groupHideAll');
      this.innerHTML = 'Open All';
      this.classList.add('accordion__section-open');
    }
  });

  const hash = window.location.hash;

  if (hash) {
    $(`${hash}`).click();
    $(`${hash} [data-toggle-group-show-all]`).click();
  }
});
